import React, { FC } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type CustomerType = 'ALL' | 'DENTHUB_PRO' | 'DENTHUB' | 'LOCAL';

type CustomerTypeFilterProps = {
    value: CustomerType;
    onTypeSelect: (type: CustomerType) => void;
    fullWidth?: boolean;
    showAllOption?: boolean;
};

const CustomerTypeFilter: FC<CustomerTypeFilterProps> = ({ value, onTypeSelect, fullWidth, showAllOption }) => {
    const { t } = useTranslation(['common', 'client-directory']);

    const handleChange = (event: SelectChangeEvent<CustomerType>) => {
        onTypeSelect(event.target.value as CustomerType);
    };

    return (
        <FormControl margin="dense" fullWidth={fullWidth} sx={{ minWidth: 150 }}>
            <InputLabel id="customer-type-label">{t('common:ORGANIZATION_TYPE')}</InputLabel>

            <Select
                id="customer-type-select"
                labelId="customer-type-label"
                value={!value ? 'DENTHUB_PRO' : value}
                label={t('common:ORGANIZATION_TYPE')}
                onChange={handleChange}
            >
                {showAllOption && <MenuItem value="ALL">{t('common:ALL')}</MenuItem>}

                <MenuItem value="DENTHUB_PRO">{t('client-directory:DENTHUB_PRO_CONNECTED')}</MenuItem>

                <MenuItem value="DENTHUB">{t('client-directory:SUPER_ADMIN_DENTHUB_CONNECTED')}</MenuItem>

                <MenuItem value="LOCAL">{t('client-directory:MY_CLIENT')}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default CustomerTypeFilter;
